<template>
    <div class="w-100" >
  
      <ui-modal
        ref="modal"
        :title="'Editar Valor Recargo - ' + id"
        transition="scale-up"
        size="large"
        @close="closeModalEvent()"
      >
        <recargos-form 
          :closeModal="cerrarModal"
          :showReset="false"
          :id="id"
          :action="'update'"
        />
      </ui-modal>
    </div>
  </template>
  
  <script>
  // Common
  import { mapActions,mapState } from "vuex";
  
  import RecargosForm from "./RecargosForm";
  
  export default {
    
    props:["id"],
  
    data() {
      return {
  
      };
    },
    methods: {
  
        ...mapActions(["ActionSetZindexTablaModal"]),
        ...mapActions("lineas", ["actionSetShowModalEditarTarifasRecargo"]),
    
        openModal(ref) {
            this.ActionSetZindexTablaModal(true);
            this.$refs[ref].open();
        },
        closeModal(ref) {
            this.$refs[ref].close();
        },
        cerrarModal(){
            this.actionSetShowModalEditarTarifasRecargo(false);
            this.ActionSetZindexTablaModal(false); 
            this.closeModal("modal");
        },
        closeModalEvent(){
          this.actionSetShowModalEditarTarifasRecargo(false);
          this.ActionSetZindexTablaModal(false); 
        }
  
    },
    computed: {
    ...mapState("lineas", ["showModalEditarTarifasRecargo"]),
      
    },
    components: {
      RecargosForm
    },
  
    watch: {
        showModalEditarTarifasRecargo: function (_new) {
            _new && this.openModal("modal");
        },
    },
  };
  </script>
  
  <style>
  
  </style>
  